import * as React from 'react';
import { HighlightsCommon } from './HighlightsCommon';

export default function Highlights() {
  return <HighlightsCommon />;
}
